export default {"src":"/_next/static/media/star-empty.979708cb.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};